import * as types from '@/store/mutation-types'
import api from '@/services/api/adminConnections'
import { handleError } from '@/utils/utils.js'
import { checkIfTokenNeedsRefresh } from '@/utils/utils.js'

const getters = {
  connections: state => state.connections,
  totalConnections: state => state.totalConnections
}

const actions = {
  getConnections({ commit }, payload) {
    //console.log('payload: '+JSON.stringify(payload,null,2))
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, false)
    return new Promise((resolve, reject) => {
      api
        .getConnections(payload)
        .then(response => {
          //console.log("getConnections: "+JSON.stringify(response.data.docs,null,2))
          if (response.status === 200) {
            commit(types.CONNECTIONS, response.data.docs)
            commit(types.TOTAL_CONNECTIONS, response.data.totalDocs)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          commit(types.SHOW_TOP_LOADING, false)
          handleError(error, commit, reject)
        })
    })
  },
  getRanking({ commit }, identity, payload) {
    checkIfTokenNeedsRefresh()
    commit(types.SHOW_TOP_LOADING, false)
    return new Promise((resolve, reject) => {
      api
        .getRanking(identity, payload)
        .then(response => {
          //console.log("getRanking: "+JSON.stringify(response.data.docs,null,2))
          if (response.status === 200) {
            commit(types.CONNECTIONS, response.data.docs)
            commit(types.TOTAL_CONNECTIONS, response.data.totalDocs)
            commit(types.SHOW_TOP_LOADING, false)
            resolve()
          }
        })
        .catch(error => {
          commit(types.SHOW_TOP_LOADING, false)
          handleError(error, commit, reject)
        })
    })
  }

}

const mutations = {
  [types.CONNECTIONS](state, connections) {
    state.connections = connections
  },
  [types.TOTAL_CONNECTIONS](state, value) {
    state.totalConnections = value
  }
}

const state = {
  connections: [],
  totalConnections: 0
}

export default {
  state,
  getters,
  actions,
  mutations
}
